import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import layer from "layui-layer";
import axios from 'axios'
import 'element-ui/lib/theme-chalk/display.css';
import './assets/v2/theme/index.css'
import './assets/fonts/iconfont.css'
import { setupTrack, trackApiRequest } from './utils/track'
import AuthPopupPlugin from './services/auth-popup'
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios
Vue.prototype.$layer = layer
Vue.use(AuthPopupPlugin)
Vue.prototype.NumberSub = function (arg1, arg2) {
    var re1, re2, m, n;
    try {
        re1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        re1 = 0;
    }
    try {
        re2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        re2 = 0;
    }
    m = Math.pow(10, Math.max(re1, re2));
    n = (re1 >= re2) ? re1 : re2;
    return this.NumFilter(((arg1 * m - arg2 * m) / m).toFixed(n));
}
Vue.prototype.NumFilter = function (value) {
    return parseFloat(value).toFixed(2);
}
axios.interceptors.request.use((config) => {
    config.__trackStart = Date.now()
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
    const config = response.config || {}
    trackApiRequest(config, response.status, response.data && response.data.code, Date.now() - (config.__trackStart || Date.now()), response.status >= 200 && response.status < 400)
    return response
}, (error) => {
    const config = error && error.config || {}
    const response = error && error.response || {}
    trackApiRequest(config, response.status || 0, response.data && response.data.code || error && error.code, Date.now() - (config.__trackStart || Date.now()), false)
    return Promise.reject(error)
});
Vue.config.productionTip = false
setupTrack(Vue, {
    appId: 'translate-web-main',
    endpoint: process.env.VUE_APP_TRACK_API || 'https://track.wesitrans.com/track',
    router,
    getToken: () => localStorage.getItem('token')
})
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
